<div *ngIf="allOrders" class="row-layout" style="width: 100%; height: 100%">
  <div style="flex: 1">
    <app-orders-grid
      #grid
      (filterChange)="onFilterChange($event)"
      (filterClickChange)="onFilterClickChange($event)"
      [datesearch]="true"
      [startdate]="startDate"
      [enddate]="endDate"
    ></app-orders-grid>
  </div>
  <div *ngIf="isAdmin">
    <div
      style="
        width: 100%;
        text-align: center;
        font-size: 1.75rem;
        margin-top: 1.5rem;
      "
    >
      Quicklinks
    </div>
    <div style="margin-top: 1rem; padding-right: 8px">
      <img
        (click)="addNewOrder()"
        src="/img/montage/add.png"
        style="width: 250px; height: 255px"
      />
    </div>
  </div>
</div>
<div *ngIf="!allOrders" style="width: 100%; height: 100%">
  <app-orders-grid
    #grid
    (filterChange)="onFilterChange($event)"
    (filterClickChange)="onFilterClickChange($event)"
    [datesearch]="true"
    [startdate]="startDate"
    [enddate]="endDate"
  ></app-orders-grid>
</div>
